import styles from "./wordmark.module.css";

export function Wordmark({ size = "small" }: { size?: "small" | "large" }) {
  return (
    <span className={`${styles.wordmark} ${size === "large" ? styles.large : ""}`}>
      <span>Hot&nbsp;Tip</span>
      <span className={styles.sd} aria-hidden="true">SD</span>
      <span className="visually-hidden">San Diego</span>
    </span>
  );
}
